module.exports = __webpack_public_path__ + "img/mqttx-light.58a1d37c.png";